import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { LoadPanel } from 'devextreme-react/load-panel';
import { Button } from 'devextreme-react/button';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from "./Layout";
import axios from "axios";
import data from "../../../../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { alert, confirm, custom } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';

var skipDataLoading = false;
const Form = (props) => {
    const formRefs = useRef({});
    var currentUser = props.oidc.user;
    let layoutId = 'A5DD90AE-F3E1-4B63-8D8B-55ECDF467AE1';
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const [customPopupQuickVisible, setCustomPopupQuickVisible] = useState(true);
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        CREATIONDATETIME: new Date(),
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: new Date(),
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: '',
        RECORDTYPE: '',
        IDENTITYID: '',
        NAME: '',
        R_DEFAULTADDRESS: null,
        INVISIBLETYPEGUID: '',
        R_PROFILE: null,
        PROFILEGUID: '',
        PROFILECODE: '',
        IDGROUP: '',
        IDSUBGROUP: '',
        REFERENCE1: '',
        REFERENCE2: '',
        DATE1: null,
        DATE2: null,
        R_CONTACT: null,
        COMMENT: '',
        CustomerCOMMENT: '',
        R_IDENTITY: null,

        AddressROWID: '00000000-0000-0000-0000-000000000000',
        AddressADDRESSNAME: '',
        AddressADDRESS1: '',
        AddressADDRESS2: '',
        AddressCITY: '',
        AddressZIP: '',
        AddressCOUNTRY: '',
        AddressTELEPHONE1: '',
        AddressTELEPHONE2: '',
        AddressFAX1: '',
        AddressFAX2: null,
        AddressMODEM1: '',
        AddressMODEM2: '',
        AddressCELLPHONE1: null,
        AddressCELLPHONE2: null,
        AddressPAGER1: null,
        AddressPAGER2: '',
        AddressEMAILADDRESS1: '',
        AddressEMAILADDRESS2: '',
        AddressWEBSITEADDRESS1: '',
        AddressWEBSITEADDRESS2: '',
        AddressSTATE: '',
        AddressALTERNATENAME: '',
        AddressLATITUDE: '',
        AddressLONGITUDE: '',
        AddressCOUNTY: '',

        AlterAddressROWID: '00000000-0000-0000-0000-000000000000',
        AlterAddressNAME: '',
        AlterAddressADDRESSNAME: '',
        AlterAddressADDRESS1: '',
        AlterAddressADDRESS2: '',
        AlterAddressCITY: '',
        AlterAddressZIP: '',
        AlterAddressCOUNTRY: '',
        AlterAddressTELEPHONE1: '',
        AlterAddressTELEPHONE2: '',
        AlterAddressFAX1: '',
        AlterAddressFAX2: null,
        AlterAddressMODEM1: '',
        AlterAddressMODEM2: '',
        AlterAddressCELLPHONE1: null,
        AlterAddressCELLPHONE2: null,
        AlterAddressPAGER1: null,
        AlterAddressPAGER2: '',
        AlterAddressEMAILADDRESS1: '',
        AlterAddressEMAILADDRESS2: '',
        AlterAddressWEBSITEADDRESS1: '',
        AlterAddressWEBSITEADDRESS2: '',
        AlterAddressSTATE: '',
        AlterAddressALTERNATENAME: '',
        AlterAddressLATITUDE: '',
        AlterAddressLONGITUDE: '',
        AlterAddressCOUNTY: '',
        DefAddress: true,

        CustomerSTATUS: 'A',
        CustomerR_TERMS: '',
        CustomerRESALENUMBER: '',
        CustomerSHIPSERVICECODE: '',
        CustomerLOTEXPIRATIONDATECHECK: '',
        CustomerSHIPSERVICEACCOUNT: '',
        CustomerR_GLDEPARTMENT: '',
        CustomerR_GLFUND: '',
        CustomerR_TAXCODE: '',
        CustomerR_TAXCODE2: '',
        CustomerOMPRINTBOL: 'Y',
        CustomerOMSENDFAX: 'Y',
        RECORD: '',
        CustomerROWID: '00000000-0000-0000-0000-000000000000',
        CustomerCREDITSTATUSFLAG: '',
        CustomerCREDITRATING: '',
        CustomerCREDITLIMIT: null,
        CustomerCREDITLASTREVIEWDATE: null,
        CustomerCREDITNEXTREVIEWDATE: null,
        CustomerDATEOPENED: null,
        CustomerLASTSTATEMENTBALANCE: null,
        CustomerCREDITCOMMENT: '',

        CustomerUSERDEFINEDCODE_1: '',
        CustomerUSERDEFINEDCODE_2: '',
        CustomerUSERDEFINEDCODE_3: '',
        CustomerUSERDEFINEDCODE_4: '',
        CustomerUSERDEFINEDCODE_5: '',
        CustomerUSERDEFINEDCODE_6: '',
        CustomerUSERDEFINEDCODE_7: '',
        CustomerUSERDEFINEDCODE_8: '',
        CustomerUSERDEFINEDCODE_9: '',
        CustomerUSERDEFINEDCODE_10: '',
        CustomerUSERDEFINEDREFERENCE_1: '',
        CustomerUSERDEFINEDREFERENCE_2: '',
        CustomerUSERDEFINEDREFERENCE_3: '',
        CustomerUSERDEFINEDREFERENCE_4: '',
        CustomerUSERDEFINEDREFERENCE_5: '',
        CustomerUSERDEFINEDREFERENCE_6: '',
        CustomerUSERDEFINEDREFERENCE_7: '',
        CustomerUSERDEFINEDREFERENCE_8: '',
        CustomerUSERDEFINEDREFERENCE_9: '',
        CustomerUSERDEFINEDREFERENCE_10: '',
        CustomerUSERDEFINEDDATE_1: null,
        CustomerUSERDEFINEDDATE_2: null,
        CustomerUSERDEFINEDDATE_3: null,
        CustomerUSERDEFINEDDATE_4: null,
        CustomerUSERDEFINEDDATE_5: null,
        CustomerUSERDEFINEDDATE_6: null,
        CustomerUSERDEFINEDDATE_7: null,
        CustomerUSERDEFINEDDATE_8: null,
        CustomerUSERDEFINEDDATE_9: null,
        CustomerUSERDEFINEDDATE_10: null,
        CustomerUSERDEFINEDCOMMENT: '',
        CustomerUSERDEFINEDQUANTITY_1: null,
        CustomerUSERDEFINEDQUANTITY_2: null,
        CustomerUSERDEFINEDQUANTITY_3: null,
        CustomerUSERDEFINEDQUANTITY_4: null,
        CustomerUSERDEFINEDQUANTITY_5: null,
        CustomerUSERDEFINEDQUANTITY_6: null,
        CustomerUSERDEFINEDQUANTITY_7: null,
        CustomerUSERDEFINEDQUANTITY_8: null,
        CustomerUSERDEFINEDQUANTITY_9: null,
        CustomerUSERDEFINEDQUANTITY_10: null,
        CustomerUSERDEFINEDCODE_11: '',
        CustomerUSERDEFINEDCODE_12: '',
        CustomerUSERDEFINEDCODE_13: '',
        CustomerUSERDEFINEDCODE_14: '',
        CustomerUSERDEFINEDCODE_15: '',
        CustomerUSERDEFINEDCODE_16: '',
        CustomerUSERDEFINEDCODE_17: '',
        CustomerUSERDEFINEDCODE_18: '',
        CustomerUSERDEFINEDCODE_19: '',
        CustomerUSERDEFINEDCODE_20: '',
        CustomerUSERDEFINEDDATE_11: null,
        CustomerUSERDEFINEDDATE_12: null,
        CustomerUSERDEFINEDDATE_13: null,
        CustomerUSERDEFINEDDATE_14: null,
        CustomerUSERDEFINEDDATE_15: null,
        CustomerUSERDEFINEDDATE_16: null,
        CustomerUSERDEFINEDDATE_17: null,
        CustomerUSERDEFINEDDATE_18: null,
        CustomerUSERDEFINEDDATE_19: null,
        CustomerUSERDEFINEDDATE_20: null,
        CustomerUSERDEFINEDQUANTITY_11: null,
        CustomerUSERDEFINEDQUANTITY_12: null,
        CustomerUSERDEFINEDQUANTITY_13: null,
        CustomerUSERDEFINEDQUANTITY_14: null,
        CustomerUSERDEFINEDQUANTITY_15: null,
        CustomerUSERDEFINEDQUANTITY_16: null,
        CustomerUSERDEFINEDQUANTITY_17: null,
        CustomerUSERDEFINEDQUANTITY_18: null,
        CustomerUSERDEFINEDQUANTITY_19: null,
        CustomerUSERDEFINEDQUANTITY_20: null,
        CustomerUSERDEFINEDREFERENCE_11: '',
        CustomerUSERDEFINEDREFERENCE_12: '',
        CustomerUSERDEFINEDREFERENCE_13: '',
        CustomerUSERDEFINEDREFERENCE_14: '',
        CustomerUSERDEFINEDREFERENCE_15: '',
        CustomerUSERDEFINEDREFERENCE_16: '',
        CustomerUSERDEFINEDREFERENCE_17: '',
        CustomerUSERDEFINEDREFERENCE_18: '',
        CustomerUSERDEFINEDREFERENCE_19: '',
        CustomerUSERDEFINEDREFERENCE_20: '',
        CustomerARACCOUNT: '',
        CustomerR_AROPENITEMDP: '',
        CustomerR_CASHRECEIPTSPORFILE: '',
        CustomerSETTLEMENTPAYGROUP: '',
        CustomerSMINVOICEEMAIL: 'N',
        CustomerR_TRADINGPARTNER: '',
        CustomerSCAC: '',
        CustomerR_SERVICESPRICING: '',
        CustomerPOPUPMESSAGE: '',
        CustomerBILLINGCYCLE: '',
        CustomerSHIPSERVICELEVEL: 'A',

        CustomerR_WMDEFAULTTRANSPROFILE: '',
        CustomerR_WMSHIPMENTPROFILE: '',
        CustomerR_WMADJUSTMENTPROFILE: '',
        CustomerR_WMRATESCHEDULE: '',
        CustomerR_WMDEFAULTITEMPROFILE: '',
        CustomerR_FMDEFAULTTRANSPROFILE: '',
        CustomerWMRICCONSOLIDATIONFLAG: 'C',
        CustomerWMSICCONSOLIDATIONFLAG: 'C',
        CustomerWMAICCONSOLIDATIONFLAG: 'C',
        CustomerWMCICCONSOLIDATIONFLAG: 'C',
        CustomerWMRICFREQUENCY: '',
        CustomerWMSICFREQUENCY: '',
        CustomerWMAICFREQUENCY: '',
        CustomerWMCICFREQUENCY: '',
        CustomerWMRTCCONSOLIDATIONFLAG: 'C',
        CustomerWMSTCCONSOLIDATIONFLAG: 'C',
        CustomerWMATCCONSOLIDATIONFLAG: 'C',
        CustomerWMCTCCONSOLIDATIONFLAG: 'C',
        CustomerWMRTCFREQUENCY: '',
        CustomerWMSTCFREQUENCY: '',
        CustomerWMATCFREQUENCY: '',
        CustomerWMCTCFREQUENCY: '',
        CustomerWMSHIPMENTSERIALNOPREFIX: '',
        CustomerWMVICSBOLNOPREFIX: '',
        CustomerMINIMUMDAILYCHARGE: null,
        CustomerFREQUENCYCODE: '',
        CustomerR_EVALUATIONEXPCODE: '',
        CustomerWMMTCFREQUENCY: '',
        CustomerWMMTCCONSOLIDATIONFLAG: 'C',
        CustomerR_FMDEFAULTDOPROFILE: '',
        CustomerR_FMFREIGHTCHARGE: '',
        CustomerR_FMFREIGHTCODE: '',
        CustomerFMCONSOLIDATEDINVOICE: '',
        CustomerBOLREQUIREMENTFLAG: '',
        CustomerPOREQUIREMENTFLAG: '',
        CustomerFMINVOICECOMMITFLAG: '',
        CustomerFMAROPENITEMDESC: '',
        CustomerR_RATESCHEDULE: '',
        CustomerFMWEIGHTBASE: '',
        CustomerR_FMBATCHPRINT: '',
        CustomerFMDEFAULTMILESCALCULATIONBASIS: '',
        CustomerFMPAYMILEAGEAPP: '',
        CustomerLIMIT53TRL: '',
        CustomerSOINVENTORYPRICELEVEL: 'A',
        CustomerR_PRICESHEDULE: '',
        CustomerNORMALOPENDAYS: null,
        CustomerPARTIALSHIPMENT: 'Y',
        CustomerR_OMDEFAULTTRANSPROFILE: '',
        CustomerR_DEFAULTSHIPTO: '',
        CustomerTAXCODESOURCE: 'P',
        CustomerOMREQUIREPO: 'N',
        CustomerCREDITOMORDERS: '',
        CustomerPAYMENTPROFILE: '',
        CustomerOMPRINTPICKSLIP: 'Y',
        CustomerOMPRINTORDERACKNOWLEDGEMENT: 'Y',
        CustomerOMPRINTDELIVERYNOTIFICATION: 'Y',
        CustomerOMPRINTPACKINGSLIP: 'Y',
        CustomerOMPRINTINVOICE: 'Y',
        CustomerOMPRINTBOL: 'Y',
        CustomerOMSENDFAX: 'N',
        CustomerOMSENDEMAIL: 'N',
        CustomerOMPICKINGSLIPREPORTTYPE: 'A',
        CustomerOMINVOICEREPORTTYPE: 'A',
        CustomerOMORDERACKNREPORTTYPE: 'A',
        CustomerCUSTOMERPURCHASEDISCOUNT: 0,
        CustomerDISCOUNTTYPE: '',
        CustomerR_DISCOUNTTABLE: '',
        CustomerIMCRGROUP: '',
        CustomerPAYMENTSYSTEM: 'N',
        CustomerPAYMENTTHRESHOLD: null,
        CustomerOMDEFAULTREPORTFORMATS: '',
        CustomerLASTSTATEMENTDATE: null,
        CustomerLASTSTATEMENTBALANCE: null,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const position = { of: '#accordion-containe2' };
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);

    const handleClick = async (e) => {
        setLoadPanelVisible(true);
        try {
            await postTransaction();
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const postTransaction = async () => {
        try {
            const url = "id/Customer/InsertCustomerDataEntry";
            let fields = formFields;
            fields.RECORDTYPE = 'R';
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (!response.data.ERRORS.length > 0) {
                notify(
                    {
                        message: "Customer Created",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                props.setCustomPopupQuickVisible(false);
                  if(typeof props.refreshDynamicLookup === 'function'){
                    props.refreshDynamicLookup(response.data.ROWID,formFields.IDENTITYID);
                    }
            } else {
                notify(
                    {
                        message: "Error: Customer Created",
                        width: 100,
                    },
                    'error',
                    3000,
                );
            }

        } catch (error) {
            notify(
                {
                    message: "Error: Customer Created",
                    width: 100,
                },
                'error',
                3000,
            );
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };
    const handleFieldChange = useCallback((name, value, e) => {
        if (name == "R_PROFILE" && !skipDataLoading) {
            GetCustomerDataFromProfile(value);
        }
    });
    const GetCustomerDataFromProfile = async (profileId) => {
        if (profileId === null)
            return;
        setLoadPanelVisible(true);
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/id/Customer/GetCustomerByProfileRowId?rowid=${profileId}`, {
                method: 'GET',
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.hasOwnProperty("data") && response.data != null && response.data != undefined && response.data != "") {
                if (response.data) {
                    setformFields(response.data);
                    setformFields(prevFields => ({
                        ...prevFields,
                        IDENTITYID: props.typeText,
                    }));
                }
            }
            else {
                console.error('Failed to get transaction profile data');
            }
        } catch (error) {
            console.error('Error fetching transaction profile data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const primaryFormLookupsLoad = () => {
        primaryFormLoad();
    }
    const primaryFormLoad = () => {
        loadLookupFromDataSource(formRefs, "CustomerR_TERMS", `${window._env_.REACT_APP_APIS}/${data.ID.GetIDTerms}`, 'id', 'name');
        loadLookupFromDataSource(formRefs, "CustomerARACCOUNT", `${window._env_.REACT_APP_APIS}/${data.AC.GetAcAccounts}`, 'id', 'name');
        if (formRefs.current['RECORD']) {
            formRefs.current['RECORD'].instance().option('disabled', true);
        }
    }
    useEffect(() => {
        setformFields(prevFields => ({
            ...prevFields,
            IDENTITYID: props.typeText,
        }));
      }, []);

          useEffect(() => {
              var rowid = props.typeText;
              if (rowid != null && rowid != undefined && rowid != '') {
                  GetHeaderInfoById(rowid);
              }
          }, [props.typeText]);
            const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response = axios.get(`${window._env_.REACT_APP_APIS}/id/Customer/GetCustomerDataByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data;
                if (responseData.ROWID) {
                    skipDataLoading = true;
                    setformFields(responseData);
                    skipDataLoading = false;
                    if (formRefs.current["R_PROFILE"]) {
                        formRefs.current["R_PROFILE"].instance().option('disabled', true);
                    }
                }
                else {
                    console.error('Failed to get transaction data');
                }
            });


        } catch (error) {
            console.error('Error failed to get transaction data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const loadLookupFromDataSource = (formRefs, name, url, valueExpr, displayExpr, loadParams = null) => {
        var dataSource = new DataSource({
            store: new createStore({
                key: valueExpr,
                loadUrl: url,
                loadParams: loadParams,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: displayExpr, desc: false }],
            paginate: true,
            pageSize: 100
        });
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }
    };
    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    return (
        <div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0 10px',
                    marginBottom: '10px'
                }}
            >
                <h6
                    style={{
                        color: window._env_.Color2,
                        margin: 0,
                        paddingLeft: '10px'
                    }}
                >
                    Customer Data Entry
                </h6>

                <div style={{ paddingRight: '10px' }}>
                    <Button
                        text="Save"
                        type="default"
                        onClick={handleClick}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <FormField
                        currrentUser={currentUser}
                        layoutId={layoutId}
                        layoutName='WMTransactionDataEntryPrimayForm'
                        defaultFormSchema={PrimaryLayout}
                        formFields={formFields}
                        setformFields={setformFields}
                        handleFieldValueChange={handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={formRefs}
                        onFormLoad={primaryFormLookupsLoad}
                        handleSelectedItemChange={handleSelectionChange}
                    />
                </div>
            </div>
        </div>
    );

};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(Form);
